// src/hooks/useWinbackConfig.js
import { useState, useEffect, useCallback } from 'react';
import { get, patch } from '../helpers/apiHelper';

const DEFAULT_CONFIG = {
    enabled: false,
    inactivityThreshold: 30,
    useIntelligentThreshold: true,
    automatic: true,
    channels: ['email'],
    excludeSegments: [],
    segmentMultipliers: {
        'Campeones': 0.5,
        'Clientes Fieles': 0.7,
        'En Riesgo': 1.0,
        'No Pueden Perderse': 0.6,
        'A Punto de Dormir': 1.2,
        'Perdidos': 1.5,
        'Sin Compras': 2.0
    },
    cooldownPeriod: 30,
    incentiveType: 'light',
    maxRewardPercentage: 0.3
};

export const useWinbackConfig = (marcaId) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadConfig = useCallback(async () => {
        if (!marcaId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await get(`marcas/${marcaId}/winback-config`);
            setConfig(response || DEFAULT_CONFIG);
        } catch (err) {
            console.error('Error loading config:', err);
            setError(err.message);
            setConfig(DEFAULT_CONFIG);
        } finally {
            setLoading(false);
        }
    }, [marcaId]);

    const updateConfig = useCallback(async (newConfig) => {
        if (!marcaId) throw new Error('No marca selected');

        try {
            const response = await patch(`marcas/${marcaId}/winback-config`, newConfig);
            setConfig(response.winbackConfig);
            return response;
        } catch (err) {
            console.error('Error updating config:', err);
            throw err;
        }
    }, [marcaId]);

    useEffect(() => {
        loadConfig();
    }, [loadConfig]);

    return {
        config,
        loading,
        error,
        updateConfig,
        refreshConfig: loadConfig
    };
};

